import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-site-feedback',
  styleUrl: 'address.css',
  shadow: true,
})
export class SiteFeedback {
  @Prop() siteFeedbackLink: string = "mailto:help@case.edu";

  render() {
    return (
      <div class="site-feedback-full">
         <p class="contact site-feedback"><a href={this.siteFeedbackLink}>Site Feedback</a></p>
      </div>
    );
  }
}
